import { createObjectFromArray } from "@/src/utils/utils";
import { notification } from "antd";
import { AdminRoutes } from "@/src/routes";

export const API_URL = {
  SERVICES: `/api/services`,
  GALLERY: `/api/gallery`,
  CLIENTS: `/api/clients`,
  CONTACT_US: `/api/contact-us`,
  TAX_INVOICE: `/api/tax-invoice`,
  BILLER_DETAILS: "/api/biller-details",
  BILLER_SERVICES: "/api/biller-services",
  VERIFY_RECAPTCHA: `/api/verify-recaptcha`,
  CLOUDINARY_IMAGE: `/api/cloudinary-image`,
  GOOGLE_SEARCH_CONSOLE: `/api/gsc`,
  GOOGLE_ANALYTICS_4: `/api/ga4`,
  GET_IP: `/api/get-ip`,
  USER_MANAGEMENT: `/api/admin-users`,
  ME: `/api/me`,
};

export const ADMIN_PAGES = {
  ANALYTICS_DASHBOARD: { label: "Analytics Dashboard", route: AdminRoutes.ANALYTICS_DASHBOARD },
  CONTACT_US_FORM: { label: "Contact Us Form", route: AdminRoutes.CONTACT_US_FORM },
  CLIENTS: { label: "Clients", route: AdminRoutes.CLIENTS },
  SERVICES: { label: "Services", route: AdminRoutes.SERVICES },
  TAX_INVOICE: { label: "Tax Invoice", route: AdminRoutes.TAX_INVOICE },
  BILLER_DETAILS: { label: "Biller Details", route: null },
  BILLER_SERVICES: { label: "Biller Services", route: null },
};

export const SERVICES = ["Central Air-Conditioning Plants", "Air-Cooled Chillers", "Water-Cooled Chillers", "Ductable Air-Conditioners", "Cassette Air-Conditioners", "Cold Room & Cold Storage", "Compressor Repairs", "Refrigerated Air Driers", "Panel Air-Conditioners", "Window & Split Air-Conditioners"];

export const SERVICES_OBJECT = createObjectFromArray(SERVICES);

export const CONTACT_SUBJECT = ["General Inquiry", "Request a Quote", "Service Request", "Annual Maintenance Contract (AMC)", "Compressor Repair Request", "Chiller Installation or Service", "Central Air-Conditioning Maintenance", "Ductable Air-Conditioners Support", "Window or Split AC Maintenance", "Panel AC Service", "Air Dryer Support", "Commercial Air-Conditioning Needs", "Emergency Assistance (24x7 Support)", "Feedback or Suggestions", "Other"];

const developer = {
  name: "Vipin Kumar",
  username: "@vipinwap07",
  credits: "Vipin Kumar (@vipinwap07)",
  email: "vipinwap07@gmail.com",
  website: "https://github.com/vipinwap07",
  github: "https://github.com/vipinwap07",
  linkedin: "https://www.linkedin.com/in/vipinwap07",
};

export const COMPANY_DETAILS = {
  name: "Indo Aircon Engineers",
  icon: "https://res.cloudinary.com/dzdcdfwww/image/upload/v1742064698/logo-4X4_jw42br.png",
  icon_grayscale: "https://res.cloudinary.com/dzdcdfwww/image/upload/e_grayscale/v1742064698/logo-4X4_jw42br.png",
  logo: "https://res.cloudinary.com/dzdcdfwww/image/upload/v1742064698/logo_oqvgog.png",
  logo_grayscale: "https://res.cloudinary.com/dzdcdfwww/image/upload/e_grayscale/v1742064698/logo_oqvgog.png",
  favicon: "https://res.cloudinary.com/dzdcdfwww/image/upload/v1742064698/favicon_flzagd.png",
  industry: "HVAC & Air Conditioning Solutions",
  gst_number: "09GQZPS2613Q1ZJ",
  pan_number: "GQZPS2613Q",
  established_year: 1991,
  services: SERVICES,
  tax_invoice: { tax_rate: 18, challan_column: false },
  bank: {
    account_holder_name: "Indo Aircon Engineers",
    name: "Kotak Mahindra Bank",
    account_number: "9445838872",
    ifsc: "KKBK0005328",
    branch: "Panchsheel Park, Sahibabad",
  },
  contact: {
    phone: ["+91 84477 08802", "+91 98101 25522"],
    email: ["indoairconengineers@gmail.com", "indo_aircon442@yahoo.com"],
    website: "https://indoairconengineers.com/",
    website_development: "https://indo-aircon-engineers.vercel.app/",
  },
  corporate_address: {
    street: "Shop No. 1, B-88, DLF Dilshad Extention-2",
    city: "Ghaziabad",
    state: "Uttar Pradesh",
    postalCode: "201005",
    country: "India",
    googleMapLink: "https://maps.app.goo.gl/dYnsBYdxdKYhxUvd7",
    googleMapEmbedLink: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3499.821294821436!2d77.3283419756058!3d28.69499187563069!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfb2b577bcc19%3A0xed0f88d8b22ef59c!2sIndo%20Aircon%20Engineer!5e0!3m2!1sen!2sin!4v1742234677318!5m2!1sen!2sin",
  },
  registered_address: {
    street: "J-602, Ajnara Integrity, Raj Nagar Extension",
    city: "Ghaziabad",
    state: "Uttar Pradesh",
    postalCode: "201017",
    country: "India",
    googleMapLink: "https://maps.app.goo.gl/ai98nHyB43P4HcCb9",
    googleMapEmbedLink: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6999.1326986951435!2d77.4135152935791!3d28.702615999999985!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cf0e31d0f8835%3A0x7ab20a3467601444!2sAjnara%20Integrity!5e0!3m2!1sen!2sin!4v1742234608494!5m2!1sen!2sin",
  },
  socialMedia: {
    whatsapp: "https://wa.me/918447708802?text=Hi,%20I%20have%20a%20query",
    facebook: "https://www.facebook.com/Indo-Aircon-Engineers-100463789240631",
    instagram: "https://www.instagram.com/indoairconengineers",
    linkedin: "https://in.linkedin.com/in/ayush-sharma-629223195",
    twitter: "https://twitter.com/indoairconeng",
  },
  founders: [
    { name: "Mr. Madan Sharma", role: "Founder" },
    { name: "Mr. Ayush Sharma", role: "CEO" },
  ],
  statistics: [
    {
      name: "Happy Clients",
      value: 1200,
      iconClassName: "icofont-simple-smile",
      className: "",
    },
    {
      name: "Service Quality",
      value: 100,
      iconClassName: "icofont-tools",
      className: "prsnt",
    },
    {
      name: "Years of Experience",
      value: 30,
      iconClassName: "icofont-chart-bar-graph",
      className: "plus",
    },
    {
      name: "Client Satisfaction",
      value: 100,
      iconClassName: "icofont-business-man",
      className: "prsnt",
    },
  ],
  developer,
};

export const LD_COMPANY_DETAILS = {
  name: "Laxmi Dyeing",
  icon: "https://res.cloudinary.com/zuwthk7x/image/upload/v1790657670/logo.png",
  icon_grayscale: "https://res.cloudinary.com/zuwthk7x/image/upload/v1790657670/logo.png",
  logo: "https://res.cloudinary.com/zuwthk7x/image/upload/v1790657670/logo.png",
  logo_grayscale: "https://res.cloudinary.com/zuwthk7x/image/upload/v1790657670/logo.png",
  favicon: "https://res.cloudinary.com/zuwthk7x/image/upload/v1790657670/logo.png",
  industry: "Textiles And Textile Articles",
  gst_number: "09AIFPK1559D1ZD",
  pan_number: "AIFPK1559D",
  established_year: 1991,
  services: [],
  tax_invoice: { tax_rate: 5, challan_column: true },
  bank: {
    account_holder_name: "Laxmi Dyeing",
    name: "Jammu & Kashmir Bank",
    account_number: "0319010100001525",
    ifsc: "JAKA0GHAZIA",
    branch: "Sector 18, Noida",
  },
  contact: {
    phone: ["+91 9958374832", "+91 8800572202"],
    email: ["pramodkumar624@gmail.com"],
    website: "https://indoairconengineers.com/",
    website_development: "https://indo-aircon-engineers.vercel.app/",
  },
  registered_address: {
    street: "Gali No-7, Mamura, Sector-66",
    city: "Noida",
    state: "Uttar Pradesh",
    postalCode: "201301",
    country: "India",
    googleMapLink: "https://maps.app.goo.gl/T5kA4hGocGoqP6cF6",
    googleMapEmbedLink: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.874075268752!2d77.37468937546193!3d28.603554285396008!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce597d85aae03%3A0x8114c166767ac2b0!2sLaxmi%20Dyeing!5e0!3m2!1sen!2sin!4v1790443761201!5m2!1sen!2sin",
  },
  socialMedia: {
    whatsapp: "https://wa.me/919958374832?text=Hi,%20I%20have%20a%20query",
    facebook: "",
    instagram: "",
    linkedin: "",
    twitter: "",
  },
  founders: [{ name: "Mr. Pramod Kumar", role: "Founder" }],
  developer,
};

export const INDIAN_STATES = [
  { name: "Jammu and Kashmir", capital: "Srinagar (Summer), Jammu (Winter)", type: "Union Territory", TIN: "01", code: "JK" },
  { name: "Himachal Pradesh", capital: "Shimla", type: "State", TIN: "02", code: "HP" },
  { name: "Punjab", capital: "Chandigarh", type: "State", TIN: "03", code: "PB" },
  { name: "Chandigarh", capital: "Chandigarh", type: "Union Territory", TIN: "04", code: "CH" },
  { name: "Uttarakhand", capital: "Dehradun", type: "State", TIN: "05", code: "UT" },
  { name: "Haryana", capital: "Chandigarh", type: "State", TIN: "06", code: "HR" },
  { name: "Delhi", capital: "New Delhi", type: "Union Territory", TIN: "07", code: "DL" },
  { name: "Rajasthan", capital: "Jaipur", type: "State", TIN: "08", code: "RJ" },
  { name: "Uttar Pradesh", capital: "Lucknow", type: "State", TIN: "09", code: "UP" },
  { name: "Bihar", capital: "Patna", type: "State", TIN: "10", code: "BH" },
  { name: "Sikkim", capital: "Gangtok", type: "State", TIN: "11", code: "SK" },
  { name: "Arunachal Pradesh", capital: "Itanagar", type: "State", TIN: "12", code: "AR" },
  { name: "Nagaland", capital: "Kohima", type: "State", TIN: "13", code: "NL" },
  { name: "Manipur", capital: "Imphal", type: "State", TIN: "14", code: "MN" },
  { name: "Mizoram", capital: "Aizawl", type: "State", TIN: "15", code: "MI" },
  { name: "Tripura", capital: "Agartala", type: "State", TIN: "16", code: "TR" },
  { name: "Meghalaya", capital: "Shillong", type: "State", TIN: "17", code: "ME" },
  { name: "Assam", capital: "Dispur", type: "State", TIN: "18", code: "AS" },
  { name: "West Bengal", capital: "Kolkata", type: "State", TIN: "19", code: "WB" },
  { name: "Jharkhand", capital: "Ranchi", type: "State", TIN: "20", code: "JH" },
  { name: "Odisha", capital: "Bhubaneshwar", type: "State", TIN: "21", code: "OR" },
  { name: "Chhattisgarh", capital: "Raipur", type: "State", TIN: "22", code: "CT" },
  { name: "Madhya Pradesh", capital: "Bhopal", type: "State", TIN: "23", code: "MP" },
  { name: "Gujarat", capital: "Gandhinagar", type: "State", TIN: "24", code: "GJ" },
  { name: "Dadra and Nagar Haveli and Daman and Diu", capital: "Daman", type: "Union Territory", TIN: "26", code: "DN" },
  { name: "Maharashtra", capital: "Mumbai", type: "State", TIN: "27", code: "MH" },
  { name: "Andhra Pradesh", capital: "Amaravati", type: "State", TIN: "37", code: "AD" },
  { name: "Karnataka", capital: "Bangalore", type: "State", TIN: "29", code: "KA" },
  { name: "Goa", capital: "Panaji", type: "State", TIN: "30", code: "GA" },
  { name: "Lakshadweep", capital: "Kavaratti", type: "Union Territory", TIN: "31", code: "LD" },
  { name: "Kerala", capital: "Thiruvananthapuram", type: "State", TIN: "32", code: "KL" },
  { name: "Tamil Nadu", capital: "Chennai", type: "State", TIN: "33", code: "TN" },
  { name: "Puducherry", capital: "Puducherry", type: "Union Territory", TIN: "34", code: "PY" },
  { name: "Andaman and Nicobar Islands", capital: "Port Blair", type: "Union Territory", TIN: "35", code: "AN" },
  { name: "Telangana", capital: "Hyderabad", type: "State", TIN: "36", code: "TS" },
  { name: "Ladakh", capital: "Leh", type: "Union Territory", TIN: "38", code: "LA" },
];

export const BILLING_UNITS = ["Nos", "Kg", "Gm", "Litre", "Ml", "Box", "Packet", "Meter", "Cm", "Piece", "Dozen", "Hour", "Day", "Month", "Sq.Ft", "Sq.M", "Set", "Pair", "Roll", "Carton", "Bag", "Ton", "Feet", "Inch", "Unit"];

export const DESCRIPTION_OF_GOODS_SERVICES = [
  { name: "Repairing & Gas Charging of AC", hsn: 6692 },
  { name: "Split AC Cooling Coil", hsn: 8415 },
  { name: "Window AC Compressor", hsn: 8414 },
  { name: "Copper Pipe for AC Installation", hsn: 7411 },
  { name: "AC Blower Motor", hsn: 8501 },
  { name: "Refrigerant Gas R410A", hsn: 3824 },
  { name: "AC Remote Control", hsn: 8537 },
  { name: "AC Indoor PCB Board", hsn: 8538 },
  { name: "AC Outdoor Fan Motor", hsn: 8501 },
  { name: "AC Drain Pipe", hsn: 3917 },
];

export const COMPANY_CODES = { IAE: "IAE", LD: "LD" };

export const COMPANY_REGISTRY = {
  [COMPANY_CODES.IAE]: COMPANY_DETAILS,
  [COMPANY_CODES.LD]: LD_COMPANY_DETAILS,
};
